var base = require('kiosk/announcements');

Vue.component('spark-kiosk-accounts', {
    mixins: [base]
});
